import { Box, Typography } from '@mui/material'
import React from 'react'
import IconReusable from '../../components/IconReusable'

const ContactUs = () => {
  return (
    <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Box>
            <Typography variant='h2'>
                Contact us
            </Typography>
            <Typography variant='body1'>
                You can get in touch with us through below mentioned platforms. Our Team will reach out to you as soon as it would be possible.
            </Typography>
        </Box>
        <Box sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: 2,
        }}>
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: '#fff',
                padding: '16px',
                borderRadius:2,
                width: { xs:'50%', md: '100%'},
                alignItems: 'center',
                gap: 2,
            }}>
                <Box sx={{
                    width: 64,
                    height: 64,
                    borderRadius: 2,
                    backgroundColor: '#F7F7F7',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <IconReusable name={'Call'} size={32} color='#995A00'/>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                    <Typography variant='h2'>Call</Typography>
                    <Typography variant='body1'>18002100123</Typography>
                </Box>
            </Box>
             <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: '#fff',
                padding: '16px',
                borderRadius:2,
                width: { xs:'50%', md: '100%'},
                alignItems: 'center',
                gap: 2,
            }}>
                <Box sx={{
                    width: 64,
                    height: 64,
                    borderRadius: 2,
                    backgroundColor: '#F7F7F7',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <IconReusable name={'Mail'} size={32} color='#995A00'/>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                    <Typography variant='h2'>Email</Typography>
                    <Typography variant='body1'>humbee.care@20p95.com</Typography>
                </Box>
            </Box>
        </Box>
    </Box>
  )
}

export default ContactUs